import React from 'react'

import PersonalInformation from './PersonalInformation'
import BusinessContactInformation from './BusinessContactInformation'
import Licenses from './Licenses'

const AppraiserProfile = (props) =>
  <div className='appraiser-profile'>
    <div className='usa-width-one-whole'>
      <div className='usa-width-one-third'>
        <PersonalInformation {...props} />
      </div>
      <div className='usa-width-two-thirds'>
        <BusinessContactInformation {...props} />
      </div>
    </div>
    <div className='usa-width-one-whole'>
      <Licenses {...props} />
    </div>
  </div>

export default AppraiserProfile
